import styled from "styled-components";
import { responsive } from "../../../../../../../../styles/constants.style";

export const CoachAssignmentWrapper = styled.div`
  margin: 0px 16px 24px;
  ${responsive.MOBILE`
    margin: 0 8px 16px 8px;
    `}
  .add-function-header {
    margin: 26px 0 0px 0;
    ${responsive.MOBILE`
      margin: 16px 0 0 0;
    `}
  }
  .add-function-container {
    margin-bottom: 24px;
    ${responsive.MOBILE`
      margin-bottom: 16px;
    `}
  }
  .add-function-button {
    padding-top: 31px;
    ${responsive.MOBILE`
      padding-top: 0;
      button {
        width: 100%
      }
    `}
  }
`;
